<div class="left-container-toolbar">
  @if (isStandardView) {
    @if (sortActive) {
      <button (click)="saveSort()" type="button" class="primary">
        {{ "generic.buttons.save" | translate }}
      </button>
      <button (click)="goBackInFaq(selectedItem)" class="cancel">
        {{ "generic.buttons.cancel" | translate }}
      </button>
    } @else {
      <button (click)="addFaq()" class="primary" type="button">
        {{ "generic.toolbar.addNew" | translate }}
      </button>
      <!--			<button *ngIf="item?.hasGuidance" (click)="addGuidance()" class="primary" type="button">
				{{'generic.toolbar.addGuidance' | translate}}
			</button>-->
      <button (click)="startSort(selectedItem)" class="primary" type="button">
        {{ "generic.toolbar.startSort" | translate }}
      </button>
    }
  }

  @if (isCreateView || isEditView) {
    <button class="primary" type="submit" form="register-form">
      {{ "generic.buttons.save" | translate }}
    </button>
  }
</div>
